

















import {Component, Vue} from "vue-property-decorator";
import Notification from "@/api/Notification";
import NotificationService from "@/service/NotificationService";
import NotificationView from "@/components/Dashboard/Notification/NotificationView.vue";
import Loading from "@/components/Shared/Loading.vue";
import RenderEmpty from "@/components/Shared/RenderEmpty.vue";

@Component({
  components: {RenderEmpty, Loading, NotificationView}
})
export default class NotificationListView extends Vue {
  private notifications: Notification[] | null = null;

  public async getNotifications() {
    this.$store.dispatch('loading/showLoadingModal');
    this.notifications = await NotificationService.getNotifications();
    this.$store.dispatch('loading/hideLoadingModal');
  }

  async mounted() {
    await this.getNotifications();
  }

  async refresh() {
    await this.getNotifications();
  }
}
